import React from 'react';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDTextButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';

const styles = () => ({
  root: {},
});

const ResendButton = ({ saving }) => {
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();
  const { challengeFlowResource, setChallengeFlowCollection } = useIdentityChallengeContext();
  const handleClick = async () => {
    try {
      const coll = await challengeFlowResource.relationship(fr.relationships.resendMfaChallenge.name).link('related').post(null, {
        deprecatedAllowAlterOfRelation: true,
      });
      setChallengeFlowCollection(coll);
      displaySuccess(`A new code has been sent to ${challengeFlowResource.attr('sentTo')}`);
    } catch (err) {
      displayErrorMessage(err, `Unable to send code to ${challengeFlowResource.attr('sentTo')}. Please contact a Facet team member.`);
    }
  };

  return (
    <FDTextButton onClick={handleClick} label={'I didn\'t receive a code'} disabled={saving} />
  );
};

ResendButton.defaultProps = {
  saving: false,
};

ResendButton.propTypes = {
  saving: PropTypes.bool,
};

export default withStyles(styles)(ResendButton);
